import { render, staticRenderFns } from "./VideoComponentVermregie.vue?vue&type=template&id=5edd0a9e&scoped=true"
import script from "./VideoComponentVermregie.vue?vue&type=script&lang=js"
export * from "./VideoComponentVermregie.vue?vue&type=script&lang=js"
import style0 from "./VideoComponentVermregie.vue?vue&type=style&index=0&id=5edd0a9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edd0a9e",
  null
  
)

export default component.exports